import { ThemeColor, colors } from "../../framework/theme";
import { t } from "i18next";

export enum TransportOrderInvoiceState {
    NotApproved,
    Approved,
    SentToIntegration
}

export interface TransportOrderInvoiceQueryParameters {
    state: TransportOrderInvoiceState;
    states?: TransportOrderInvoiceState[];
    customerId: string;
    createdDateTime: string;
    selectedStates?: TransportOrderInvoiceState[];
}

interface transportOrderInvoiceStateInfo {
    value: TransportOrderInvoiceState;
    name: string;
    color: string;
    colorName: ThemeColor;
}

export const transportOrderInvoiceStates: readonly transportOrderInvoiceStateInfo[] = Object.freeze([
    { value: TransportOrderInvoiceState.NotApproved, name: t("invoice.notApproved"), color: colors.yellow.main, colorName: "yellow" },
    { value: TransportOrderInvoiceState.Approved, name: t("invoice.approved"), color: colors.green.main, colorName: "green" },
    { value: TransportOrderInvoiceState.SentToIntegration, name: t("invoice.sent"), color: colors.blue.main, colorName: "blue" },
]);
